import Buildings from "./buildings.vue";

export default Buildings;



// WEBPACK FOOTER //
// ./src/components/_buildings/index.js